__turbopack_context__.v({
  "blocksBackgroundColor": "video-module-scss-module__9pynzG__blocksBackgroundColor",
  "blocksFontColor": "video-module-scss-module__9pynzG__blocksFontColor",
  "contain": "video-module-scss-module__9pynzG__contain" + " " + "video-module-scss-module__9pynzG__video",
  "container": "video-module-scss-module__9pynzG__container",
  "cover": "video-module-scss-module__9pynzG__cover" + " " + "video-module-scss-module__9pynzG__video",
  "secondaryNavBackgroundColor": "video-module-scss-module__9pynzG__secondaryNavBackgroundColor",
  "themeBackgroundColor": "video-module-scss-module__9pynzG__themeBackgroundColor",
  "themeFontColor": "video-module-scss-module__9pynzG__themeFontColor",
  "themeFontFamily": "video-module-scss-module__9pynzG__themeFontFamily",
  "video": "video-module-scss-module__9pynzG__video",
});
